import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { AudioWebhookResponse } from '../../SessionConnectionContextProvider/useSessionConnectionContext';
import useSessionDetectionContext from '../../SessionDetectionContextProvider/useSessionDetectionContext';
import useSessionInfoContext from '../../SessionInfoContextProvider/useSessionInfoContext';
import useWebsocketApiConnectionContext from '../WebsocketApiConnectionContext/useWebsocketApiConnectionContext';
import useAudioWebsocketApiConnectionContext from './useAudioWebsocketApiConnectionContext';

function useMessageHandling(message: AudioWebhookResponse | null) {
  const queryClient = useQueryClient();
  const { session, setSessionId } = useSessionInfoContext();
  const { setLatestDetection } = useSessionDetectionContext();

  React.useEffect(() => {
    if (message && message.type) {
      switch (message.type) {
        case 'detection':
          setLatestDetection(message.message.detection);
          break;

        case 'session-change':
          queryClient.setQueryData(
            ['getLiveSession', { input: { id: message.sessionId } }],
            { getSession: { ...session, id: message.sessionId, detections: [] } },
          );
          queryClient.invalidateQueries(['getLiveSession', { input: { id: message.sessionId } }]);

          setSessionId(message.sessionId);
          if (message.detection.detection) {
            setLatestDetection(message.detection.detection);
          }
          break;

        default:
          break;
      }
    }
  }, [message]);
}

export default function DetectionUpdater({ children }: { children: React.ReactNode }) {
  const { lastJsonMessage: lastAudioJsonMessage } = useAudioWebsocketApiConnectionContext();
  const { lastJsonMessage: lastWebsocketJsonMessage } = useWebsocketApiConnectionContext();

  useMessageHandling(lastAudioJsonMessage);
  useMessageHandling(lastWebsocketJsonMessage as any as AudioWebhookResponse);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return (<>{children}</>);
}
